import React, { useEffect } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AsideProfessor } from '../../_layout/aside-professor';
import { CreateBoardList } from '../board/boardList';
import * as toast from '../../_store/slice/toast';

export function LectureReferenceRoom(routeProps: RouteComponentProps) {
  const history = useHistory();
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      (window.localStorage.getItem('part') !== 'professor' &&
        window.localStorage.getItem('authority') !== 'A')
    ) {
      dispatch(toast.error({ message: '교수 회원님 전용 공간입니다.' }));
      history.push('/');
    }
  }, []);

  return (
    <main className="sub list wrapper">
      <AsideProfessor />
      <div className="content">
        {CreateBoardList(
          routeProps,
          {
            title: '강의자료실',
            subTitle: '교수님들을 위한 강의자료실입니다.',
            mainTitle: '교수님 전용',
            visableButton: false,

            ctgy: 'lecture-lib',
            viewUrl: '/professor/boardView',
          },
          () => {},
          true
        )}
      </div>
    </main>
  );
}
